import React, { useEffect, useRef, useState } from "react";
import { Box, LinearProgress } from "@mui/material";
import {
  SHARE_CARD_HEIGHT,
  SHARE_CARD_WIDTH,
  buildVerifyUrl,
  paintShareCardFaces,
} from "../../utils/triviaShareCard";
import { mountShareCard3D } from "../../utils/triviaShareCard3d";
import { getShareCardTheme } from "../../utils/triviaShareCardTiers";

const TriviaShareCardScene = ({ card, width = "min(280px, 78vw)", onFrontReady }) => {
  const mountRef = useRef(null);
  const onFrontReadyRef = useRef(onFrontReady);
  onFrontReadyRef.current = onFrontReady;
  const [isPainting, setIsPainting] = useState(true);
  const theme = getShareCardTheme(card);
  const verifyUrl = buildVerifyUrl(
    typeof window !== "undefined" ? window.location.origin : "",
    card.shareToken
  );

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return undefined;
    let cancelled = false;
    let scene = null;
    setIsPainting(true);
    paintShareCardFaces({ ...card, verifyUrl }).then(({ front, back }) => {
      if (cancelled) return;
      onFrontReadyRef.current?.(front);
      scene = mountShareCard3D({
        mount,
        frontCanvas: front,
        backCanvas: back,
        edge: theme.edge,
        reduceMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
      });
      setIsPainting(false);
    });
    return () => {
      cancelled = true;
      scene?.dispose();
    };
  }, [
    card.mode,
    card.grade,
    card.correct,
    card.total,
    card.score,
    card.sportLabel,
    card.username,
    card.shareToken,
    card.tier,
    verifyUrl,
    theme.edge,
  ]);

  return (
    <Box sx={{ width, mx: "auto" }}>
      {isPainting ? <LinearProgress /> : null}
      <Box
        ref={mountRef}
        aria-label="Trivia share card preview"
        sx={{
          width: "100%",
          aspectRatio: `${SHARE_CARD_WIDTH} / ${SHARE_CARD_HEIGHT}`,
          cursor: "grab",
          touchAction: "none",
        }}
      />
    </Box>
  );
};

export default TriviaShareCardScene;
